// Base UTL of the backend API
var PANELCHANGER_BASEURL = window.location.href.includes('sandozpanelchangerqa') ? 'https://sandozpanelchangerfunction-qa.azurewebsites.net/api' : 
                           process.env.NODE_ENV === 'production' ? 'https://sandozpanelchangerfunction.azurewebsites.net/api' : 
                           'http://localhost:7071/api';

export { PANELCHANGER_BASEURL }